<form #userProfileForm="ngForm" name="userProfileForm"
  (ngSubmit)="partnerSelector.isValid() && userProfileForm.valid && save(userProfileForm)" novalidate>
  <div class="container container-fixed" id="profileDiv">
    <!--  column headers outside flex row -->
    <div class="row">
      <div class="col-sm-6">
        <h2>User profile @if (isBuiltIn) {
          <span class="label label-info">BuiltIn User</span>
        }</h2>
      </div>
      <div class="col-sm-6">
        <h2>Usergroups</h2>
      </div>
    </div>
    <div class="flex-row">
      <div class="item">
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <div class="form-group">
              <label title="Name used for display">Display Name</label>
              <input class="form-control" [ngClass]="{'invalid-state-border':displayName.errors}"
                name="displayName" #displayName="ngModel" required type="text"
                [ngModel]="$safeNavigationMigration(clonedUser?.DisplayName)" (ngModelChange)="clonedUser.DisplayName = $event"
                [readonly]="!isEditable" />
                @if (displayName.errors && (displayName.dirty || displayName.touched || userProfileForm.submitted)) {
                  <div
                  class="error">Please enter the display name</div>
                }
              </div>

              <div class="form-group">
                <label title="Users e-mail address">E-mail</label>
                <input class="form-control" [ngClass]="{'invalid-state-border':email.errors}" name="email"
                  #email="ngModel" required
                  pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$"
                  type="email" [ngModel]="$safeNavigationMigration(clonedUser?.EmailAddress)"
                  (ngModelChange)="clonedUser.EmailAddress = $event" [readonly]="!isEditable" />
                  @if (email.errors && (email.dirty || email.touched || userProfileForm.submitted)) {
                    <div
                      class="error">
                      @if (email.errors.required) {
                        <div class="error">Please enter the email address</div>
                      }
                      @if (email.errors.pattern) {
                        <div class="error">
                          Please enter valid email address (must
                          be lowercase)
                        </div>
                      }
                    </div>
                  }
                </div>
                @if (clonedUser?.UserId) {
                  <div class="form-group">
                    <label title="Chosen username to use for logon">Username</label>
                    <div class="input-group">
                      <input class="form-control" name="clonedUserName" type="text"
                        [ngModel]="$safeNavigationMigration(clonedUser?.Credentials?.UserName)" readonly />
                        <span class="input-group-btn">
                          <button id="btnChangeUsername" class="btn btn-default"
                            [disabled]="!changeUsernameAllowed || isAdAuthentication"
                            (click)="changeUsername()" type="button">
                            Change <span class="glyphicon glyphicon-edit"></span>
                          </button>
                        </span>
                      </div>
                    </div>
                  }
                  @if (!clonedUser?.UserId) {
                    <div class="form-group">
                      <label title="Chosen username to use for logon">Username</label>
                      @if (isEditable) {
                        <div>
                          <input class="form-control" [ngClass]="{'invalid-state-border':userName.errors}"
                            name="userName" #userName="ngModel" required type="text"
                            [ngModel]="$safeNavigationMigration(clonedUser?.Credentials?.Username)"
                            (ngModelChange)="clonedUser.Credentials.Username = $event" />
                            @if (userName.errors && (userName.dirty || userName.touched || userProfileForm.submitted)) {
                              <div
                              class="error">Please enter the user name</div>
                            }
                          </div>
                        }
                      </div>
                    }

                    @if (clonedUser?.UserId) {
                      <div class="form-group">
                        <label title="Chosen password to use for logon">Password</label>
                        <div class="input-group">
                          <input class="form-control" name="clonedUserpassword" type="password" value="*********"
                            readonly />
                            <span class="input-group-btn">
                              <button id="btnChangePassword" class="btn btn-default"
                                [disabled]="!changePasswordAllowed || isAdAuthentication"
                                (click)="changePassword()" type="button">
                                Change <span class="glyphicon glyphicon-edit"></span>
                              </button>
                            </span>
                          </div>
                        </div>
                      }
                      @if (!clonedUser?.UserId) {
                        <div class="form-group">
                          <label title="Chosen password to use for logon">Password</label>
                          @if (isEditable) {
                            <div>
                              <input class="form-control" [ngClass]="{'invalid-state-border':password.errors}"
                                name="password" #password="ngModel" required minlength="8" type="password"
                                [ngModel]="$safeNavigationMigration(clonedUser?.Credentials?.Password)"
                                (ngModelChange)="clonedUser.Credentials.Password = $event" />
                                @if (password.errors && (password.dirty || password.touched || userProfileForm.submitted)) {
                                  <div class="error">
                                    @if (password.errors.required) {
                                      <div>Please enter the password</div>
                                    }
                                    @if (password.errors.minlength) {
                                      <div>Password must consist of at least 8 characters</div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        }

                        <div class="form-group">
                          <label title="Only present when using AD integration">Domain Account Name</label>
                          <input class="form-control" name="docmainAccount" type="text"
                            [ngModel]="$safeNavigationMigration(clonedUser?.Credentials?.DomainAccountName)" readonly />
                          </div>

                          <div class="form-group">
                            <label title="Default partner associated with the user">Partner</label>
                            <ep-partner-selector name="selectPartner" #partnerSelector
                              [isReadOnly]="!isEditable || noAccessToDefaultPartner" [isRequired]="false"
                              [selectedPartner]="defaultPartner"
                              (selectedPartnerChange)="clonedUser.PartnerId = $event?.PartnersId">
                            </ep-partner-selector>
                            <!--<div *ngIf="!partnerSelector.isValid() && userProfileForm.submitted" class="error">Please select the partner</div>-->
                            @if (noAccessToDefaultPartner) {
                              <div class="alert alert-warning" role="alert">
                                No access to view or edit selected partner
                              </div>
                            }
                            <!--<biz-partner-selector partner-selector-settings="{partnerStateHolderKey: 'userProfilePartner'}" is-disabled="!isEditable" selected-partner="selectedPartner"></biz-partner-selector>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <br class="xs-20" />
                      <div class="row">
                        <div class="col-sm-12">
                          @for (userGroup of userGroups; track userGroup) {
                            <div class="form-group control control-checkbox">
                              <label>
                                {{userGroup.Name}}
                                <input type="checkbox" [disabled]="!isEditable || !userGroup.isEditable"
                                  [name]="'checkbox_usergroup_' + userGroup.Id" value="{{userGroup.Name}}"
                                  [(ngModel)]="userGroup.selected"><i></i>
                                </label>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        @if (!isEditable && editAllowed && !clonedUser?.IsDisabled) {
                          <button id="btnEditUserProfile" type="button" class="btn btn-primary" (click)="edit()"
                            [disabled]="isAdAuthentication">
                            Edit
                          </button>
                        }
                        @if (isEditable) {
                          <button id="btnSaveUserProfile" type="submit" class="btn btn-success" name="btnSave"
                            >
                            Save
                          </button>
                        }
                        @if (isEditable) {
                          <button id="btnCancelUserProfile" type="button" class="btn btn-link" (click)="cancel()"
                            >
                            Cancel
                          </button>
                        }
                        @if (!isEditable && showUserAccessOverviewAllowed) {
                          <button id="btnShowFullAccessModel" type="button" class="btn btn-link"
                            (click)="showAllPermissions()">
                            Show full access model
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </form>

                @if (!newUser && setMfaAllowed && !isAdAuthentication) {
                  <div class="container container-fixed" id="mfaDiv">
                    <hr />
                    <h1>Multi factor authentication</h1>
                    <div class="row">
                      @if (!allowShowManageMfa) {
                        <div class="col-sm-6">
                          <div class="form-group modal-body">
                            <span class="errorText">
                              Managing MFA is currently not available, while missing email setup.
                            </span>
                          </div>
                        </div>
                      }
                      @if (allowShowManageMfa) {
                        <div class="col-sm-6">
                          <h2>Manage</h2>
                          <div class="row">
                            <div class="col-sm-6">
                              @if (!isMfaEnabled) {
                                <button type="button" class="btn btn-link" (click)="enableMFA()">
                                  Enable MFA
                                </button>
                              }
                              @if (isMfaEnabled) {
                                <button type="button" class="btn btn-link" (click)="disableMFA()">
                                  Disable MFA
                                </button>
                              }
                            </div>
                          </div>
                          @if (isMfaEnabled) {
                            <div class="row">
                              <div class="col-sm-6">
                                <button type="button" class="btn btn-link" (click)="resendMFASecret()">Resend MFA secret</button>
                              </div>
                            </div>
                          }
                          @if (isMfaEnabled) {
                            <div class="row">
                              <div class="col-sm-6">
                                <button type="button" class="btn btn-link" (click)="generateNewMfaSecret()">
                                  Generate new MFA secret
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }

                <ng-template #changePasswordTemplate let-c="close" let-d="dismiss">
                  <form #changePasswordForm="ngForm" (ngSubmit)="c(passwordDraft1); changePasswordForm.resetForm(); passwordDraft1=''; passwordDraft2='';">
                    <div class="modal-header">
                      <button type="button" class="close" aria-label="Close" (click)="d(); changePasswordForm.resetForm(); passwordDraft1=''; passwordDraft2='';">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4 class="modal-title">Change password</h4>
                    </div>
                    <div class="form-group modal-body">
                      <div class="form-group">
                        <label>New password</label>
                        <input autofocus class="form-control" type="password" name="password1" [(ngModel)]="passwordDraft1" #password1="ngModel" required minlength="8" />
                        @if (password1.errors && (password1.dirty || password1.touched)) {
                          <div class="error">
                            @if (password1.errors.required) {
                              <div>Password is required</div>
                            }
                            @if (password1.errors.minlength) {
                              <div>Password must consist of at least 8 characters</div>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label>Type new password again</label>
                        <input class="form-control" type="password" name="password2" [(ngModel)]="passwordDraft2" #password2="ngModel" required />
                        @if (password2.errors && (password2.dirty || password2.touched)) {
                          <div class="error">
                            @if (password2.errors.required) {
                              <div>Confirmation is required</div>
                            }
                          </div>
                        }
                        @if (!password2.errors && (password2.dirty || password2.touched) && passwordDraft2 && (passwordDraft1 !== passwordDraft2)) {
                          <div class="error">
                            Passwords must match
                          </div>
                        }
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary" [disabled]="changePasswordForm.invalid || passwordDraft1 !== passwordDraft2">Ok</button>
                      <button type="button" class="btn btn-link" (click)="d(); changePasswordForm.resetForm(); passwordDraft1=''; passwordDraft2='';">Cancel</button>
                    </div>
                  </form>
                </ng-template>

                <ng-template #userAccessDetailsTemplate let-c="close" let-d="dismiss">
                  <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="d()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Access model for this user</h4>
                  </div>
                  <div class="form-group modal-body">
                    <div class="form-group">
                      <input autofocus #textBoxSearchDetails class="form-control" type="text" (keyup)="0"
                        placeholder="Search..." />
                      </div>
                      <dx-tree-view [items]="userAccessDetails" [width]="400" [searchValue]="textBoxSearchDetails.value">
                      </dx-tree-view>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" (click)="c()">Ok</button>
                    </div>
                  </ng-template>

                  <ng-template #enableMfaTemplate let-c="close" let-d="dismiss">
                    <div class="modal-header">
                      <button type="button" class="close" aria-label="Close" (click)="d()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4 class="modal-title">Multi Factor Authentication</h4>
                    </div>
                    <div class="form-group modal-body">
                      <span>
                        This will enable multi factor authentication. You will receive an email with the secret to be used in your
                        authenticator app.
                      </span>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" (click)="c()">Enable MFA</button>
                      <button type="button" class="btn btn-primary" (click)="d()">Cancel</button>
                    </div>
                  </ng-template>

                  <ng-template #disableMfaTemplate let-c="close" let-d="dismiss">
                    <div class="modal-header">
                      <button type="button" class="close" aria-label="Close" (click)="d()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4 class="modal-title">Multi Factor Authentication</h4>
                    </div>
                    <div class="form-group modal-body">
                      <span>
                        This will disable multi factor authentication. You will no longer be required to enter an athentication
                        code when you login.
                      </span>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" (click)="c()">Disable MFA</button>
                      <button type="button" class="btn btn-primary" (click)="d()">Cancel</button>
                    </div>
                  </ng-template>

                  <ng-template #regenerateSecretTemplate let-c="close" let-d="dismiss">
                    <div class="modal-header">
                      <button type="button" class="close" aria-label="Close" (click)="d()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <h4 class="modal-title">Multi Factor Authentication</h4>
                    </div>
                    <div class="form-group modal-body">
                      <span>
                        This will generate a new secret. The existing secret will no longer be valid and a new one will be send to
                        your email address.
                      </span>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" (click)="c()">Generate new secret</button>
                      <button type="button" class="btn btn-primary" (click)="d()">Cancel</button>
                    </div>
                  </ng-template>

                  <!-- PERSONAL ACCESS TOKENS -->
                  @if (!newUser && showPersonalAccessTokensAllowed) {
                    <div class="container container-fixed" style="margin-bottom: 20px;">
                      <hr />
                      <div class="row">
                        <div class="col-sm-12">
                          <h1>Personal Access Tokens</h1>
                          <i>Personal Access Tokens (PAT) can be used when using the Link API</i>
                          <dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='userPats' [bizSetColumnChooser]="false" [bizSetGroupPanel]="false"
                            [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="false" [bizSetPager]="false" [bizHideSelectedRowsCompnent]="true"
                            (onInitNewRow)="onInitNewRowPAT($event)" (onRowInserted)="onRowInsertedPAT($event)"
                            (onRowUpdated)="onRowUpdatedPAT($event)" (onRowRemoving)="onRowRemovingPAT($event)">
                            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                            <dxo-group-panel [visible]="false"></dxo-group-panel>
                            <dxo-editing mode="row"
                              [allowUpdating]="allowUpdatingPAT"
                              [allowAdding]="allowAddingPAT"
                              [allowDeleting]="allowDeletingPAT">
                              <dxo-popup title="Personal access tokens" [showTitle]="true"></dxo-popup>
                            </dxo-editing>
                            <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
                              <dxi-validation-rule type="required"></dxi-validation-rule>
                            </dxi-column>
                            <dxi-column dataField="ExpireDate" caption="Expire date" dataType="datetime" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
                            <dxi-column dataField="ScopesInternal" caption="Scopes" cellTemplate="scopesTemplate" editCellTemplate="scopesEditTemplate" [calculateFilterExpression]="calculateScopesFilterExpression">
                              <dxo-header-filter [dataSource]="getScopesFilterData()"></dxo-header-filter>
                            </dxi-column>
                            <dxi-column type="buttons">
                              <dxi-button name="edit"></dxi-button>
                              <dxi-button name="delete"></dxi-button>
                              <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="allowShowLogPAT">
                              </dxi-button>
                            </dxi-column>
                            <ng-container *dxTemplate="let cell of 'logTemplate'">
                              <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                                <app-change-log-link-entity type="PersonalAccessTokenEntity" [id]="cell.data.Id"></app-change-log-link-entity>
                              </app-change-log-link>
                            </ng-container>
                            <ng-container *dxTemplate="let cell of 'scopesTemplate'">
                              <span>{{ cell?.value?.join(', ') ?? '(null)' }}</span>
                            </ng-container>
                            <ng-container *dxTemplate="let cell of 'scopesEditTemplate'">
                              <dx-tag-box [dataSource]="apiScopes" [(value)]="cell.value" displayExpr="DisplayName" valueExpr="Name"
                                placeholder="Select scopes..." applyValueMode="useButtons" [showSelectionControls]="true" [disabled]="false"
                                (onValueChanged)="onScopeValueChanged($event, cell)">
                              </dx-tag-box>
                            </ng-container>
                          </dx-data-grid>
                        </div>
                      </div>
                    </div>
                  }
